import apiConfig from '../api/api-config';
import urlJoin from 'url-join';

export const createFileUrl=(appFile)=>{
    if(!appFile || !appFile.id)
        return;

    return urlJoin(apiConfig.host, 'file', appFile.id+'');
};
